import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { ServiceCookies } from '@services/ServiceCookies';
import { wrapperFetchCheckedValidateToken } from '@sharedHelpers/wrapperFetchCheckedValidateToken';

export const fetchUserProfile = createAsyncThunk('user/fetchUserProfile', async data => {
  return await wrapperFetchCheckedValidateToken(async () => {
    return await MyAxios.post('/api/user/profile', data, {
      headers: {
        [ServiceCookies.JWT_HEADER]: ServiceCookies.jwtAccess,
      },
    })
      .then(handleResponse)
      .catch(handleError);
  });
});
